// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"572":"936af076","917":"7dcb0c06"}[chunkId] + ".chunk.css";
};